import React from 'react';
import ProductPropertyRequestList from '../ProductPropertyRequestList';

const ProductPropertyRequestListWrap = (props) => {
  const { categorySelectList, productList, getProductSubCategoryList, getList, getExcelDownload } = props;

  return (
    <div>
      <ProductPropertyRequestList
        categorySelectList={categorySelectList}
        productListInfo={{
          list: productList.list,
          filterOption: productList.filterOption,
          sortOption: productList.sortOption,
          pagination: productList.pagination,
          summary: productList.summary,
        }}
        getList={getList}
        mainProductCategorySelectList={productList.mainProductCategorySelectList}
        subProductCategorySelectList={productList.subProductCategorySelectList}
        getExcelDownload={getExcelDownload}
        getProductSubCategoryList={getProductSubCategoryList}
      />
    </div>
  );
};

export default ProductPropertyRequestListWrap;
